import axios from "../../js/project-axios.js"

const list = () => {
    return axios.get("/capital/subject/list");
};

const add = subject => {
    return axios.post("/capital/subject/add", subject);
};

const update = subject => {
    return axios.post("/capital/subject/update", subject);
};

export default {
    list,
    add,
    update
};